export const state = {
  cycle: localStorage.getItem("cycle") ? localStorage.getItem("cycle") : new Date().getFullYear(),
  department: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).department : {},
  deliveryUnit: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).department.deliveryUnit : {},
  office: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).department.deliveryUnit.office : {},
  campus: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).department.deliveryUnit.office.campus : {},
  agency: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).department.deliveryUnit.office.campus.agency : {},
  rootFileDirectory: process.env.VUE_APP_BACKEND_FILES_ROOT_URL,
  uploadURL: process.env.VUE_APP_BACKEND_FILES_URL,
  decipherCode: "$b14cA5898a4e4142@@@2ea2143a2410",
  selectedCampus: localStorage.getItem("selectedCampus")
    ? JSON.parse(localStorage.getItem("selectedCampus"))
    : JSON.parse(localStorage.getItem("user"))
    ? JSON.parse(localStorage.getItem("user")).department.deliveryUnit.office.campus
    : {},
  selectedDU: localStorage.getItem("selectedDU")
    ? JSON.parse(localStorage.getItem("selectedDU"))
    : JSON.parse(localStorage.getItem("user"))
    ? {...JSON.parse(localStorage.getItem("user")).department.deliveryUnit, withDeliveryUnitAccess: JSON.parse(localStorage.getItem("user")).withDeliveryUnitAccess}
    : {},
  selectedDepartment: localStorage.getItem("selectedDeparment")
  ? JSON.parse(localStorage.getItem("selectedDeparment"))
  : JSON.parse(localStorage.getItem("user"))
  ? JSON.parse(localStorage.getItem("user")).department
  : {},
  globalStop: false,
};
export const mutations = {
  changeCycle(state, data) {
    localStorage.setItem("cycle", data);
    state.cycle = data;
  },
  changeCampus(state, data) {
    localStorage.setItem("selectedCampus", JSON.stringify(data));
    state.selectedCampus = data;
  },
  changeDU(state, data) {
    localStorage.setItem("selectedDU", data ? JSON.stringify(data) : null);
    state.selectedDU = data;
  },
  changeDepartment(state, data) {
    localStorage.setItem("selectedDeparment", data ? JSON.stringify(data) : null);
    state.selectedDepartment = data;
  },
  mutateGlobalStop(state, data) {
    state.globalStop = data;
  },
};
export const getters = {
  getCycle(state) {
    return state.cycle;
  },
  getCampus(state) {
    return state.selectedCampus;
  },
  getDU(state) {
    return state.selectedDU;
  },
  getDepartment(state) {
    return state.selectedDepartment;
  },
};
export const actions = {
  mutateGlobalStop(context, data) {
    context.commit("mutateGlobalStop", data);
  },
};
